import Layout from '@/layout'
import store from '@/store'

// 获取论文节点
let processList = store.getters.thesisProcess
if (!processList) {
  processList = []
  // 处理后台免密登录的获取不到论文节点的问题
  store.dispatch('user/GetThesisNodeList').then(res => {
    window.location.reload()
  })
}

// 选导节点
// const tutorProcess = {
//   path: `process/selection`,
//   name: 'Selection',
//   component: () => import('@/views/MyThesis/process/index.vue'),
//   meta: { title: '导师遴选', children: null }
// }

// 按照路由格式生成路由配置
let processMenu = []

if (processList.length > 0) {
  processMenu = [
    // tutorProcess,
    ...processList.map(item => {
      return {
        path: `process/${item.node}`,
        name: item.node,
        component: () => import('@/views/MyThesis/process/index.vue'),
        meta: {
          title: item.title,
          children: item.children || null
        }
      }
    })
  ]
}

const children = [
  {
    path: 'thesis-notice-list',
    name: 'ThesisNoticeList',
    component: () => import('@/views/MyThesis/NoticeList/index.vue'),
    meta: { title: '通知' }
  },
  {
    path: 'thesis-notice-list/:id',
    name: 'ThesisNoticeDetail',
    component: () => import('@/views/MyThesis/NoticeList/detail.vue'),
    meta: { title: '通知详情', hidden: true, isShowSidebar: false }
  },
  {
    path: 'thesis-documents',
    name: 'thesisDocuments',
    component: () => import('@/views/MyThesis/documents/index.vue'),
    meta: { title: '论文相关文档' }
  },
  ...processMenu
]

const myThesis = {
  path: '/my-thesis',
  component: Layout,
  title: '我的论文',
  name: 'MyThesis',
  redirect: '/my-thesis/thesis-notice-list',
  meta: { title: '我的论文', name: 'MyThesis' },
  children
}

export default myThesis
